import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { BehaviourSettingServices } from '../../../../../services/BehaviourSetting.services'
import { FormArray, FormBuilder, FormGroup } from '@angular/forms'
import { SharedServices } from '../../../../../services/shared.services'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'

@Component({
    selector: 'app-modal-behavior-option-setting',
    templateUrl: './modal-behavior-option-setting.component.html',
    styleUrls: [
        './modal-behavior-option-setting.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/main-view.component.css',
        '../../../../../stagingcss/image-viewer.component.css',

    ],
})
export class ModalBehaviorOptionSettingComponent implements OnInit, OnDestroy {

    option_behaviour: any = 'hidden'
    jsonAllOptionSetting: any = {
        timeline: [],
        message: [],
        room: [],
    }

    title: any = ''
    tabArray: any = ''
    arrTag: any[] = [
        { title: 'title 1', _id: '59807b56a2b640e343a5dbc1' },
        { title: 'title 2', _id: '59807b56a2b640e343a5dbc2' },
        { title: 'title 3', _id: '59807b56a2b640e343a5dbc3' },
        { title: 'title 4', _id: '59807b56a2b640e343a5dbc4' },
    ]
    // arrRoom: any[] = [];
    // arrMessage: any[] = [];

    // arrShow: any[] = [];
    modalOptionForm: FormGroup

    // arrSave: any[] = [];
    view: any = 'option-setting'

    items: any
    tags = []
    tagType = ''
    changeEmittedOptionSetting: any
    tagList = {}

    constructor(private behaviourSettingServices: BehaviourSettingServices,
                private authData: AuthService,
                private restApi: RestServices,
                private _sharedService: SharedServices,
                private formBuilder: FormBuilder) {

    }

    ngOnInit() {
        this.modalOptionForm = this.formBuilder.group({
            items: this.formBuilder.array([]),
        })
        this.items = this.modalOptionForm.get('items') as FormArray
        this.option_behaviour = 'hidden'
        this.getStatusOptionSetting()
        // this._sharedService.changeEmittedSource$.subscribe(success => {
        // 	if (success === 'saveOption') {
        // 		this.saveOption();
        // 	}
        // });
    }

    ngOnDestroy(): void {
        if(this.changeEmittedOptionSetting)
            this.changeEmittedOptionSetting.unsubscribe()
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        const showView: any = this.behaviourSettingServices.returnView()
        if (showView != '' && showView == this.view) {
            if (keyPressed == 27) {
                if (event) {
                    event.preventDefault()
                }
                this.closeModal('close')
            } else if (keyPressed == 13) {
                event.preventDefault()
            }
        }
    }

    getStatusOptionSetting() {
        this.changeEmittedOptionSetting = this.behaviourSettingServices.changeEmittedOptionSetting$.subscribe(data => {
            if (data && data.action == 'active') {
                this.tagList = data.data
                this.tagType = data['optionSetting']
                if (this.tagList[this.tagType] && this.tagList[this.tagType].length > 0) {
                    this.tags = $.extend(true, [], this.tagList[this.tagType])
                    this.tags.forEach(e => {
                        this.items.push(this.assignTag(e))
                    })
                }
                switch (this.tagType) {
                    case 'chatTag':
                        this.title = 'Communication tag'
                        break
                    case 'chatPrivateTag':
                        this.title = 'Chat tag'
                        break
                    case 'noteTag':
                        this.title = 'Timeline tag'
                        break
                    case 'roomMessageTag':
                        this.title = 'Message tag'
                        break
                    case 'roomTag':
                        this.title = 'Room tag'
                        break
                    default:
                        this.title = 'Timeline tag'
                        break
                }
                this.option_behaviour = data.action
            }
        })
    }

    createTag(): FormGroup {
        const id = new Date().getTime().toString()
        return this.formBuilder.group({
            title: '',
            _id: id,
        })
    }

    assignTag(tag): FormGroup {
        return this.formBuilder.group({
            title: tag.title,
            _id: tag._id,
        })
    }

    // saveOption() {
    //     const actions = {
    //         collection: 'setting',
    //         id: 'option',
    //         type: 'update',
    //     };
    //     actions['value'] = this.tagList;
    // 	const resourceData = {
    //         actions: [actions],
    //         status: {
    // 			clinic: {
    // 				paths: {
    // 					'{}': true
    // 				}
    // 			}, setting: {
    // 				map: {
    // 					common: true, alignerMail: true, movieMail: true, option: true, testMail: true
    // 				}, paths: {
    // 					'{}': true
    // 				}
    // 			}, staff: {
    // 				paths: {
    // 					'{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true
    // 				}
    // 			}
    // 		}
    //         };
    //         this.authData.authToken().then(tokenReNew => {
    //             this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
    //                 this.tags = [];
    //                 this.tagList = {};
    //                 this.closeModal('close');
    //             });
    //         });
    // }

    remove(index) {
        this.items.removeAt(index)
    }

    moveUp(index, item) {
        this.items.removeAt(index)
        this.items.insert(index - 1, item)
    }

    moveDown(index, item) {
        this.items.removeAt(index)
        this.items.insert(index + 1, item)
    }

    addItem() {
        this.items.push(this.createTag())
    }

    closeModal(action) {
        this.option_behaviour = 'hidden'
        const optionSetting: any = {}
        optionSetting['optionSetting'] = this.tagType
        optionSetting['action'] = action
        if (action == 'saveClose') {
            this.tagList[this.tagType] = $.extend(true, [], this.items.value)
        }
        optionSetting['data'] = this.tagList
        this.behaviourSettingServices.emitChangeOptionSetting(optionSetting)
        this.modalOptionForm.reset()
        this.tagList = {}
        this.tags = []
        this.items['controls'] = []
        this.items.value = []
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/behavior/modal-behavior-option-setting/modal-behavior-option-setting.component.ts